'use client';

import {useCallback} from 'react';

import {AppType, NO_CATEGORY_CATEGORY} from '@web-catalog/types';

import {useRunAfterAuthorizationDoneWithVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';

type Props = {
  appType: AppType;
  categoryName: string | null;
};

export const ViewReporter = ({appType, categoryName}: Props) => {
  useRunAfterAuthorizationDoneWithVkId(
    useCallback(
      (vk_id) => {
        if (!categoryName) {
          logTmrEvent({
            logEvent:
              appType === AppType.GAMES
                ? 'game.interesting.view'
                : 'app.interesting.view',
            params: {vk_id},
          });
          return;
        }
        if (categoryName === NO_CATEGORY_CATEGORY) {
          logTmrEvent({
            logEvent: appType === AppType.MAIN ? 'apps.view' : 'games.view',
            params: {vk_id},
          });
          return;
        }
        logTmrEvent({
          logEvent:
            appType === AppType.MAIN ? 'appCategory.view' : 'gameCategory.view',
          params: {vk_id, app_category_name: categoryName},
        });
      },
      [appType, categoryName],
    ),
  );
  return null;
};
